/**
 * Pill toggle matching Accessibility settings (Settings → Accessibility).
 * On: track uses --text-rgb; off: --border-rgb; white thumb; translate-x-6 / translate-x-1.
 */
import type { ButtonHTMLAttributes } from 'react'

export type SwitchProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'type'> & {
  checked: boolean
}

export function Switch({ checked, className = '', disabled, ...props }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(var(--text-rgb),0.35)] disabled:opacity-50 disabled:cursor-not-allowed ${
        checked ? 'bg-[rgb(var(--text-rgb))]' : 'bg-[rgb(var(--border-rgb))]'
      } ${className}`}
      {...props}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
          checked ? 'translate-x-6' : 'translate-x-1'
        }`}
      />
    </button>
  )
}
